const Target = ({ color = '#000', ...props }) => (
  <svg
    width="30"
    height="30"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1000 1000"
    {...props}
  >
    <path
      d="M 350 60 A 470 470 0 1 1 60 350"
      fill="none"
      stroke="#F6A237"
      strokeWidth="45"
      strokeLinecap="round"
      transform="rotate(90 500 500)"
    />
    <path
      d="M 380 190 A 330 330 0 1 1 190 380"
      fill="none"
      stroke="#F6A237"
      strokeWidth="45"
      strokeLinecap="round"
      transform="rotate(90 500 500)"
    />
    <path
      d="M 440 310 A 190 190 0 1 1 310 440"
      fill="none"
      stroke="#F6A237"
      strokeWidth="45"
      strokeLinecap="round"
      transform="rotate(90 500 500)"
    />
    <path
      d="M 500 500 L 700 300"
      fill="none"
      stroke={color || '#F6A237'}
      strokeWidth="45"
      strokeLinecap="round"
    />
    <path
      d="M 700 300 L 730 120 L 800 50 L 830 180 L 960 210 L 890 280 L 700 300"
      fill="none"
      stroke={color || '#F6A237'}
      strokeWidth="45"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Target
